const Description = () => {
  return (
    <>
      <div className="hidden px-4 sm:block sm:px-8 lg:px-28">
        <h2 className="mb-2 font-bold">What Makes TBD, The Best Deals App?</h2>
        <p className="pl-[10px]">
          TBD isn’t just like another Telegram loot deals page; it is more than
          that. The app brings you the best deals from all the top online stores
          and helps you stay updated on price drops for your favourite products.
          TBD functions as an Amazon price tracker, Flipkart price tracker, and
          even a Myntra price tracker, letting you to track price fluctuations
          with ease. Plus, you can customize deal groups based on your preferred
          categories or top online stores, all in one place.
        </p>
      </div>
    </>
  );
};

export default Description;
